import { trimTrailingZeros } from '@/utils/format/trimTrailingZeros'

const VAT_RATE = 0.2

const VAT_MULTIPLIER = 1 + VAT_RATE

export const withVat = (price: number) => price * VAT_MULTIPLIER

export const getVatAmount = (price: number) => price * VAT_RATE

export const formatPriceWithVat = (price: number) =>
  trimTrailingZeros(withVat(price))
